module.exports = __webpack_public_path__ + "img/reconciliation.ee471e66.svg";